const AboutMe = () => {
    return (
      <section id="AboutMe" className="about--section">
          <div className="about--section--img">
              <img src="./img/me.jpeg"  alt="About"/>
          </div>
          <div className="hero--section--content--box about--section--box">
              <div className="hero--section--content">
                  <p className="section--title">Insights</p>
                  <h1 className="skills-section--heading">About Me</h1>
                  <p className="hero--section-description">
                      I'm a seasoned MERN Stack developer, wielding code like a sculptor's chisel to mold data into secure, scalable web experiences. From crafting elegant UIs in React to orchestrating robust backends in Node.js, I build solutions that thrive under pressure and captivate users. Performance optimization is my mantra, ensuring every interaction feels effortless. My fluency in MongoDB, Express.js, React, and Node.js allows me to weave seamless user experiences from the database to the pixel-perfect UI. 
                  </p>
                  <p className="hero--section-description">
                  As a MERN Stack developer, I'm on a mission to push the boundaries of web experiences. I channel my passion for user delight into every line of code, crafting interfaces that whisper empathy and guide users effortlessly. Performance optimization is my obsession, ensuring every interaction feels like a breath of fresh air. Let's join forces and build the future of the web, one captivating experience at a time.
                  </p>
              </div>
          </div>
      </section>
    )
  }
  
  export default AboutMe